import { nanoid } from 'nanoid';

import { WorkflowNodeType } from '../constants';
import { FlowNodeRegistry } from '../../typings';
import iconJs from '../../assets/icon-js.png';
import { formMeta } from './js-meta';

// 定义 JS 节点注册信息
const JSNodeRegistry: FlowNodeRegistry = {
  type: WorkflowNodeType.JS,
  label: '执行 JS',
  meta: {},
  info: {
    icon: iconJs,
    description: '执行js代码',
  },
  formMeta,
  onAdd(ctx) {
    return {
      id: `${WorkflowNodeType.JS}_${nanoid(5)}`,
      type: WorkflowNodeType.JS,
      data: {
        title: '执行 JS',
      },
    };
  },
};

export { JSNodeRegistry };
